<template>
    <v-container fluid fill-height>
        <v-layout align-center >
            <v-flex xs12 text-xs-center>
                <h4>Você não tem permissão para acessar esta página. Entre em contato com o administrador do sistema.</h4>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
  name: 'AcessoNegado'
}
</script>


// WEBPACK FOOTER //
// src/components/pages/paginas-informativas/AcessoNegado.vue